// Compares a part card with the part already chosen for the same step.
// Both sides are { grams, price } for what the build would carry: pairs
// (tyres, cages) are the pair weight and the pair price, like the cards.
const MINUS = '−';

function euros(value) {
  // Prices are shown as plain numbers to the cent with trailing zeros dropped.
  return String(+Math.abs(value).toFixed(2));
}

function perGram(value) {
  const digits = value >= 10 ? 0 : value >= .1 ? 1 : 2;
  return String(+value.toFixed(digits));
}

function signed(value, text) {
  return `${value < 0 ? MINUS : '+'}${text}`;
}

export function weightDelta(candidate, selected) {
  if (!candidate || !selected) return null;
  const known = side => side.grams != null && side.grams >= 0 && side.price != null && side.price >= 0;
  if (!known(candidate) || !known(selected)) return null;
  const grams = Math.round(candidate.grams - selected.grams);
  const price = +(candidate.price - selected.price).toFixed(2);
  if (!grams && !price) return { grams, price, perGram: null, win: false, label: 'Same weight and price' };

  const weightText = grams ? `${signed(grams, Math.abs(grams))} g` : '±0 g';
  // Lighter and pricier: what each gram saved costs.
  if (grams < 0 && price > 0) {
    const rate = price / -grams;
    return { grams, price, perGram: rate, win: false, label: `${weightText} · ${perGram(rate)} €/g` };
  }
  const priceText = price ? `${signed(price, euros(price))} €` : '±0 €';
  // No heavier and no dearer, and better on at least one.
  const win = grams <= 0 && price <= 0;
  return { grams, price, perGram: null, win, label: `${weightText} · ${priceText}` };
}
